type ReadableSpanWithParent = {
  parentSpanContext?: { spanId: string };
  parentSpanId?: string;
};

export function getReadableSpanParentId(span: unknown): string | undefined {
  const spanWithParent = span as ReadableSpanWithParent;

  // Different OpenTelemetry SDK versions expose parent linkage on different
  // properties at runtime.
  return (
    spanWithParent.parentSpanContext?.spanId ?? spanWithParent.parentSpanId
  );
}
